
import React, { useState } from "react";
import {
    Box,
    Container,
    Grid,
    List,
    ListItemButton,
    ListItemText,
    Paper,
    Typography,
    Divider,
    TextField,
    InputAdornment,
    Chip,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import parse from "html-react-parser";
import wikiData from "../../data/wikiData";

const WikiPage = () => {
    const [selectedId, setSelectedId] = useState(wikiData[0].id);
    const [search, setSearch] = useState("");

    const selected =
        wikiData.find((w) => w.id === selectedId) ||
        wikiData[0];

    const filteredData = wikiData.filter((w) =>
        w.title.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <Box
            sx={{
                minHeight: "100vh",
                position: "relative",
                overflow: "hidden",
                py: { xs: 5, sm: 7, md: 10 },
                background:
                    "radial-gradient(circle at 50% -10%, rgba(255,84,32,0.15), transparent 35%), radial-gradient(circle at 100% 45%, rgba(213,47,12,0.045), transparent 30%), linear-gradient(180deg, #030303 0%, #080808 55%, #020202 100%)",
                color: "#fff",
                fontFamily: "'Poppins', sans-serif",

                "&:before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "65%",
                    height: "1px",
                    background:
                        "linear-gradient(90deg, transparent, rgba(255,84,32,0.85), transparent)",
                },

                "&:after": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    backgroundImage:
                        "linear-gradient(rgba(255,84,32,0.018) 1px, transparent 1px), linear-gradient(90deg, rgba(255,84,32,0.018) 1px, transparent 1px)",
                    backgroundSize: "45px 45px",
                    pointerEvents: "none",
                },
            }}
        >
            {/* =========================================================
                BACKGROUND FIRE GLOW - TOP RIGHT
            ========================================================== */}
            <Box
                sx={{
                    position: "absolute",
                    top: "-280px",
                    right: "-280px",
                    width: "700px",
                    height: "700px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(255,84,32,0.12) 0%, rgba(181,42,13,0.035) 38%, transparent 68%)",
                    filter: "blur(110px)",
                    pointerEvents: "none",
                    zIndex: 0,
                }}
            />

            {/* =========================================================
                BACKGROUND FIRE GLOW - BOTTOM LEFT
            ========================================================== */}
            <Box
                sx={{
                    position: "absolute",
                    bottom: "-320px",
                    left: "-320px",
                    width: "750px",
                    height: "750px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(255,84,32,0.055) 0%, rgba(142,29,11,0.02) 38%, transparent 68%)",
                    filter: "blur(120px)",
                    pointerEvents: "none",
                    zIndex: 0,
                }}
            />

            {/* =========================================================
                CENTER EMBER GLOW
            ========================================================== */}
            <Box
                sx={{
                    position: "absolute",
                    top: "40%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "650px",
                    height: "650px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(255,84,32,0.025), transparent 70%)",
                    filter: "blur(110px)",
                    pointerEvents: "none",
                    zIndex: 0,
                }}
            />

            <Container
                maxWidth="xl"
                sx={{
                    position: "relative",
                    zIndex: 2,
                }}
            >
                {/* =====================================================
                    HERO
                ====================================================== */}
                <Paper
                    elevation={0}
                    sx={{
                        position: "relative",
                        overflow: "hidden",
                        borderRadius: {
                            xs: "22px",
                            md: "30px",
                        },
                        p: {
                            xs: 3,
                            sm: 4,
                            md: 6,
                        },
                        mb: {
                            xs: 4,
                            md: 5,
                        },
                        background:
                            "linear-gradient(145deg, rgba(18,10,8,0.99), rgba(8,8,8,0.99))",
                        border:
                            "1px solid rgba(255,84,32,0.16)",
                        boxShadow:
                            "0 25px 70px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.025)",

                        "&:before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            height: "2px",
                            background:
                                "linear-gradient(90deg, transparent, #b52a0d, #ff5420, #ff9a4d, #ff5420, #b52a0d, transparent)",
                            boxShadow:
                                "0 0 14px rgba(255,84,32,0.2)",
                        },
                    }}
                >
                    {/* HERO GLOW */}

                    <Box
                        sx={{
                            position: "absolute",
                            top: "-160px",
                            right: "-160px",
                            width: "420px",
                            height: "420px",
                            borderRadius: "50%",
                            background:
                                "radial-gradient(circle, rgba(255,84,32,0.10), transparent 70%)",
                            filter: "blur(80px)",
                            pointerEvents: "none",
                        }}
                    />

                    <Box
                        sx={{
                            position: "absolute",
                            bottom: "-180px",
                            left: "-180px",
                            width: "350px",
                            height: "350px",
                            borderRadius: "50%",
                            background:
                                "radial-gradient(circle, rgba(181,42,13,0.035), transparent 70%)",
                            filter: "blur(70px)",
                            pointerEvents: "none",
                        }}
                    />

                    <Grid
                        container
                        spacing={{
                            xs: 4,
                            md: 6,
                        }}
                        alignItems="center"
                    >
                        {/* =================================================
                            HERO LEFT
                        ================================================== */}
                        <Grid item xs={12} md={7}>
                            <Chip
                                icon={
                                    <MenuBookRoundedIcon
                                        sx={{
                                            color: "#ff7135 !important",
                                        }}
                                    />
                                }
                                label="GUIDES • GAMEPLAY • INFORMATION"
                                sx={{
                                    mb: 2.5,
                                    height: 34,
                                    background:
                                        "rgba(255,84,32,0.075)",
                                    border:
                                        "1px solid rgba(255,84,32,0.18)",
                                    color: "#ff7135",
                                    fontWeight: 800,
                                    fontSize: "10px",
                                    letterSpacing: "0.8px",
                                    boxShadow:
                                        "0 0 18px rgba(255,84,32,0.035)",
                                    "& .MuiChip-label": {
                                        px: 1.5,
                                    },
                                }}
                            />

                            <Typography
                                sx={{
                                    color: "#fff",
                                    fontWeight: 900,
                                    fontSize: {
                                        xs: "38px",
                                        sm: "50px",
                                        md: "68px",
                                    },
                                    lineHeight: 0.98,
                                    letterSpacing: "-1px",
                                    mb: 2.5,
                                    textShadow:
                                        "0 5px 30px rgba(0,0,0,0.65)",
                                }}
                            >
                                Vex
                                <br />
                                <Box
                                    component="span"
                                    sx={{
                                        color: "#ff7135",
                                        textShadow:
                                            "0 0 30px rgba(255,84,32,0.25)",
                                    }}
                                >
                                    Wiki
                                </Box>
                            </Typography>

                            <Typography
                                sx={{
                                    color:
                                        "rgba(255,255,255,0.55)",
                                    fontSize: {
                                        xs: "14px",
                                        md: "17px",
                                    },
                                    lineHeight: 1.85,
                                    maxWidth: "650px",
                                }}
                            >
                                Everything you need to know about
                                Vex Conquer in one place. Explore
                                guides, gameplay information, systems,
                                and useful tips.
                            </Typography>

                            {/* FIRE LINE */}

                            <Box
                                sx={{
                                    width: 75,
                                    height: 3,
                                    borderRadius: "10px",
                                    background:
                                        "linear-gradient(90deg, #ff5420, #ff9a4d, transparent)",
                                    mt: 3,
                                    boxShadow:
                                        "0 0 12px rgba(255,84,32,0.2)",
                                }}
                            />

                            {/* SERVER TAGS */}

                            <Box
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 1,
                                    mt: 3,
                                }}
                            >
                                {[
                                    "5165 CLASSIC",
                                    "LEVEL 130",
                                    "1ST REBORN",
                                    "CLASSIC PVP",
                                ].map((tag) => (
                                    <Box
                                        key={tag}
                                        sx={{
                                            px: 1.5,
                                            py: 0.7,
                                            borderRadius: "6px",
                                            border:
                                                "1px solid rgba(255,84,32,0.14)",
                                            background:
                                                "rgba(255,84,32,0.035)",
                                            color: "#777",
                                            fontSize: "9px",
                                            fontWeight: 800,
                                            letterSpacing: "1.1px",
                                        }}
                                    >
                                        {tag}
                                    </Box>
                                ))}
                            </Box>
                        </Grid>

                        {/* =================================================
                            QUICK TIPS
                        ================================================== */}
                        <Grid item xs={12} md={5}>
                            <Box
                                sx={{
                                    position: "relative",
                                    background:
                                        "linear-gradient(145deg, rgba(255,84,32,0.045), rgba(10,10,10,0.97))",
                                    border:
                                        "1px solid rgba(255,84,32,0.15)",
                                    borderRadius: "22px",
                                    p: {
                                        xs: 2.5,
                                        md: 3.5,
                                    },
                                    boxShadow:
                                        "0 15px 45px rgba(0,0,0,0.4)",
                                    overflow: "hidden",

                                    "&:before": {
                                        content: '""',
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "1px",
                                        background:
                                            "linear-gradient(90deg, transparent, rgba(255,84,32,0.55), transparent)",
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1.5,
                                        mb: 3,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 40,
                                            height: 40,
                                            borderRadius: "12px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background:
                                                "rgba(255,84,32,0.09)",
                                            border:
                                                "1px solid rgba(255,84,32,0.15)",
                                            boxShadow:
                                                "0 0 18px rgba(255,84,32,0.035)",
                                        }}
                                    >
                                        <AutoAwesomeRoundedIcon
                                            sx={{
                                                color: "#ff7135",
                                                fontSize: 20,
                                            }}
                                        />
                                    </Box>

                                    <Box>
                                        <Typography
                                            sx={{
                                                color: "#fff",
                                                fontWeight: 900,
                                                fontSize: "15px",
                                            }}
                                        >
                                            Quick Tips
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color: "#555",
                                                fontSize: "10px",
                                                mt: 0.2,
                                            }}
                                        >
                                            KNOW BEFORE YOU PLAY
                                        </Typography>
                                    </Box>
                                </Box>

                                {[
                                    "Upgrade wisely and save resources.",
                                    "Guild Wars are highly competitive.",
                                    "All classes are balanced for PvP.",
                                    "Use marketplace for trading.",
                                ].map((tip, i) => (
                                    <Box
                                        key={i}
                                        sx={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                            gap: 1.5,
                                            mb:
                                                i === 3
                                                    ? 0
                                                    : 2,
                                            p: 1,
                                            borderRadius: "10px",
                                            transition:
                                                "all 0.2s ease",

                                            "&:hover": {
                                                background:
                                                    "rgba(255,84,32,0.045)",
                                            },
                                        }}
                                    >
                                        <ShieldRoundedIcon
                                            sx={{
                                                color: "#ff7135",
                                                fontSize: 17,
                                                mt: 0.2,
                                                flexShrink: 0,
                                            }}
                                        />

                                        <Typography
                                            sx={{
                                                color: "#aaa",
                                                fontSize: "12px",
                                                lineHeight: 1.6,
                                            }}
                                        >
                                            {tip}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>

                {/* =====================================================
                    MAIN CONTENT
                ====================================================== */}
                <Grid
                    container
                    spacing={{
                        xs: 3,
                        md: 4,
                    }}
                    alignItems="flex-start"
                >
                    {/* =================================================
                        SIDEBAR
                    ================================================== */}
                    <Grid item xs={12} md={4}>
                        {/* SEARCH */}

                        <TextField
                            fullWidth
                            placeholder="Search wiki..."
                            value={search}
                            onChange={(e) =>
                                setSearch(e.target.value)
                            }
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon
                                            sx={{
                                                color: "#ff7135",
                                                fontSize: 21,
                                            }}
                                        />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                mb: 2,

                                "& .MuiOutlinedInput-root": {
                                    background:
                                        "linear-gradient(145deg, rgba(18,10,8,0.98), rgba(8,8,8,0.98))",
                                    color: "#fff",
                                    borderRadius: "15px",
                                    height: 52,

                                    "& fieldset": {
                                        borderColor:
                                            "rgba(255,84,32,0.14)",
                                    },

                                    "&:hover fieldset": {
                                        borderColor:
                                            "rgba(255,84,32,0.3)",
                                    },

                                    "&.Mui-focused fieldset": {
                                        borderColor:
                                            "#ff5420",
                                        boxShadow:
                                            "0 0 12px rgba(255,84,32,0.08)",
                                    },
                                },

                                "& input": {
                                    fontSize: "13px",
                                },

                                "& input::placeholder": {
                                    color: "#555",
                                    opacity: 1,
                                },
                            }}
                        />

                        {/* TOPICS CARD */}

                        <Paper
                            elevation={0}
                            sx={{
                                borderRadius: {
                                    xs: "20px",
                                    md: "22px",
                                },
                                background:
                                    "linear-gradient(145deg, rgba(18,10,8,0.99), rgba(8,8,8,0.99))",
                                border:
                                    "1px solid rgba(255,84,32,0.15)",
                                overflow: "hidden",
                                boxShadow:
                                    "0 20px 55px rgba(0,0,0,0.5)",
                                position: "relative",

                                "&:before": {
                                    content: '""',
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: "2px",
                                    background:
                                        "linear-gradient(90deg, transparent, #ff5420, #ff9a4d, #ff5420, transparent)",
                                },
                            }}
                        >
                            {/* SIDEBAR HEADER */}

                            <Box
                                sx={{
                                    p: {
                                        xs: 2.5,
                                        md: 3,
                                    },
                                    borderBottom:
                                        "1px solid rgba(255,255,255,0.05)",
                                    background:
                                        "rgba(255,84,32,0.025)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#ff7135",
                                        fontSize: "10px",
                                        fontWeight: 800,
                                        letterSpacing: "2px",
                                        textTransform:
                                            "uppercase",
                                        mb: 0.7,
                                    }}
                                >
                                    KNOWLEDGE BASE
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#fff",
                                        fontWeight: 900,
                                        fontSize: "20px",
                                    }}
                                >
                                    Wiki Topics
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#555",
                                        fontSize: "11px",
                                        mt: 0.5,
                                    }}
                                >
                                    Select a topic to learn more.
                                </Typography>
                            </Box>

                            {/* TOPIC LIST */}

                            <List
                                sx={{
                                    p: 1,
                                }}
                            >
                                {filteredData.map((w) => (
                                    <ListItemButton
                                        key={w.id}
                                        selected={
                                            selectedId ===
                                            w.id
                                        }
                                        onClick={() =>
                                            setSelectedId(
                                                w.id
                                            )
                                        }
                                        sx={{
                                            position:
                                                "relative",
                                            borderRadius:
                                                "12px",
                                            mb: 0.5,
                                            minHeight: 48,
                                            color: "#fff",
                                            transition:
                                                "all 0.2s ease",

                                            "&.Mui-selected": {
                                                background:
                                                    "linear-gradient(90deg, rgba(255,84,32,0.13), rgba(255,84,32,0.025))",

                                                "&:before": {
                                                    content:
                                                        '""',
                                                    position:
                                                        "absolute",
                                                    left: 0,
                                                    top: "20%",
                                                    width: 3,
                                                    height: "60%",
                                                    borderRadius:
                                                        "10px",
                                                    background:
                                                        "#ff5420",
                                                    boxShadow:
                                                        "0 0 12px rgba(255,84,32,0.55)",
                                                },
                                            },

                                            "&:hover": {
                                                background:
                                                    "rgba(255,84,32,0.055)",
                                            },
                                        }}
                                    >
                                        <ListItemText
                                            primary={
                                                <Typography
                                                    sx={{
                                                        color:
                                                            selectedId ===
                                                            w.id
                                                                ? "#ff7135"
                                                                : "#bbb",
                                                        fontWeight:
                                                            selectedId ===
                                                            w.id
                                                                ? 800
                                                                : 600,
                                                        fontSize:
                                                            "13px",
                                                    }}
                                                >
                                                    {w.icon}{" "}
                                                    {w.title}
                                                </Typography>
                                            }
                                        />
                                    </ListItemButton>
                                ))}

                                {/* NO SEARCH RESULTS */}

                                {filteredData.length === 0 && (
                                    <Box
                                        sx={{
                                            py: 5,
                                            px: 2,
                                            textAlign:
                                                "center",
                                        }}
                                    >
                                        <SearchIcon
                                            sx={{
                                                color: "#333",
                                                fontSize: 35,
                                                mb: 1,
                                            }}
                                        />

                                        <Typography
                                            sx={{
                                                color: "#666",
                                                fontSize: "12px",
                                            }}
                                        >
                                            No wiki topics found.
                                        </Typography>
                                    </Box>
                                )}
                            </List>
                        </Paper>
                    </Grid>

                    {/* =================================================
                        CONTENT
                    ================================================== */}
                    <Grid item xs={12} md={8}>
                        <Paper
                            elevation={0}
                            sx={{
                                borderRadius: {
                                    xs: "20px",
                                    md: "24px",
                                },
                                background:
                                    "linear-gradient(145deg, rgba(18,10,8,0.99), rgba(8,8,8,0.99))",
                                border:
                                    "1px solid rgba(255,84,32,0.15)",
                                boxShadow:
                                    "0 25px 65px rgba(0,0,0,0.55)",
                                overflow: "hidden",
                                position: "relative",

                                "&:before": {
                                    content: '""',
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: "2px",
                                    background:
                                        "linear-gradient(90deg, transparent, #b52a0d, #ff5420, #ff9a4d, #ff5420, #b52a0d, transparent)",
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    p: {
                                        xs: 3,
                                        sm: 4,
                                        md: 5,
                                    },
                                }}
                            >
                                {/* CONTENT LABEL */}

                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems:
                                            "center",
                                        gap: 1,
                                        mb: 1.5,
                                    }}
                                >
                                    <MenuBookRoundedIcon
                                        sx={{
                                            color: "#ff7135",
                                            fontSize: 17,
                                        }}
                                    />

                                    <Typography
                                        sx={{
                                            color: "#ff7135",
                                            fontSize: "10px",
                                            fontWeight: 800,
                                            letterSpacing:
                                                "2px",
                                            textTransform:
                                                "uppercase",
                                        }}
                                    >
                                        Vex Wiki
                                    </Typography>
                                </Box>

                                {/* TITLE */}

                                <Typography
                                    sx={{
                                        color: "#fff",
                                        fontWeight: 900,
                                        fontSize: {
                                            xs: "30px",
                                            sm: "36px",
                                            md: "46px",
                                        },
                                        lineHeight: 1.1,
                                        letterSpacing:
                                            "-0.5px",
                                        wordBreak:
                                            "break-word",
                                        textShadow:
                                            "0 5px 25px rgba(0,0,0,0.5)",
                                    }}
                                >
                                    {selected.title}
                                </Typography>

                                {/* TITLE ACCENT */}

                                <Box
                                    sx={{
                                        width: 55,
                                        height: 3,
                                        borderRadius: "10px",
                                        background:
                                            "linear-gradient(90deg, #ff5420, #ff9a4d, transparent)",
                                        mt: 2,
                                        boxShadow:
                                            "0 0 10px rgba(255,84,32,0.2)",
                                    }}
                                />

                                <Divider
                                    sx={{
                                        my: 3,
                                        borderColor:
                                            "rgba(255,255,255,0.06)",
                                    }}
                                />

                                {/* ARTICLE */}

                                <Box
                                    sx={{
                                        color: "#bbb",

                                        "& strong": {
                                            color: "#ff7135",
                                            fontWeight: 800,
                                        },

                                        "& p": {
                                            marginTop: 0,
                                        },

                                        "& ul": {
                                            paddingLeft:
                                                "22px",
                                        },

                                        "& li": {
                                            marginBottom:
                                                "8px",
                                        },

                                        "& a": {
                                            color: "#ff9a4d",
                                            fontWeight: 700,
                                        },

                                        "& code": {
                                            color: "#ff9a4d",
                                            background:
                                                "rgba(255,84,32,0.07)",
                                            padding:
                                                "2px 6px",
                                            borderRadius:
                                                "5px",
                                        },
                                    }}
                                >
                                    {selected.content
                                        .split("\n")
                                        .map((line, i) => {
                                            const trimmed =
                                                line.trim();

                                            if (!trimmed)
                                                return (
                                                    <Box
                                                        key={i}
                                                        sx={{
                                                            height: 8,
                                                        }}
                                                    />
                                                );

                                            const html =
                                                trimmed.replace(
                                                    /\*\*(.*?)\*\*/g,
                                                    "<strong>$1</strong>"
                                                );

                                            return (
                                                <Typography
                                                    key={i}
                                                    sx={{
                                                        mb: 2,
                                                        color:
                                                            "#aaa",
                                                        fontSize: {
                                                            xs: "13px",
                                                            md: "14px",
                                                        },
                                                        lineHeight: 1.9,
                                                    }}
                                                >
                                                    {parse(
                                                        html
                                                    )}
                                                </Typography>
                                            );
                                        })}
                                </Box>

                                {/* ARTICLE FOOTER */}

                                <Box
                                    sx={{
                                        mt: 4,
                                        pt: 3,
                                        borderTop:
                                            "1px solid rgba(255,255,255,0.06)",
                                        display: "flex",
                                        alignItems:
                                            "center",
                                        justifyContent:
                                            "space-between",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems:
                                                "center",
                                            gap: 1.2,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 6,
                                                height: 6,
                                                borderRadius:
                                                    "50%",
                                                background:
                                                    "#ff5420",
                                                boxShadow:
                                                    "0 0 10px rgba(255,84,32,0.55)",
                                            }}
                                        />

                                        <Typography
                                            sx={{
                                                color:
                                                    "rgba(255,255,255,0.32)",
                                                fontSize: "10px",
                                                fontWeight: 700,
                                                letterSpacing:
                                                    "2px",
                                            }}
                                        >
                                            VEX CONQUER • 5165
                                        </Typography>
                                    </Box>

                                    <Typography
                                        sx={{
                                            color: "#444",
                                            fontSize: "9px",
                                            fontWeight: 700,
                                            letterSpacing:
                                                "1px",
                                        }}
                                    >
                                        KNOWLEDGE BASE
                                    </Typography>
                                </Box>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>

                {/* =====================================================
                    BOTTOM BRAND ACCENT
                ====================================================== */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 2,
                        mt: {
                            xs: 5,
                            md: 7,
                        },
                    }}
                >
                    <Box
                        sx={{
                            width: {
                                xs: 45,
                                sm: 75,
                            },
                            height: "1px",
                            background:
                                "linear-gradient(90deg, transparent, rgba(255,84,32,0.25))",
                        }}
                    />

                    <Typography
                        sx={{
                            color: "#444",
                            fontSize: "10px",
                            fontWeight: 700,
                            letterSpacing: "2px",
                            textTransform: "uppercase",
                        }}
                    >
                        Vex Conquer • 5165 Classic
                    </Typography>

                    <Box
                        sx={{
                            width: {
                                xs: 45,
                                sm: 75,
                            },
                            height: "1px",
                            background:
                                "linear-gradient(90deg, rgba(255,84,32,0.25), transparent)",
                        }}
                    />
                </Box>
            </Container>
        </Box>
    );
};

export default WikiPage;

